// modules.js — con aiTag (para overlay) y ai (metadata estructurada)
// Campos NUEVOS agregados dentro de "ai":
// - family: "base" | "upper" | "tall" | "skirting"
// - subfamily (opcional): "upper35" | "upperBridge"
// - depth_cm: número con la profundidad visual (p.ej. 60, 58, 35, 40)
// - front_plane: "flush" | "recessed" | "flush-with-bases"
// - column: boolean (true si es columna/tall que cuenta como “columna”)
// - bbox_policy: "strict" (no inventar ni mover tipos)
// - allow_autofill: false (evitar que la IA rellene con este tipo)
// - visual_signature (opcional): pistas fuertes (seams/cajones, etc.)

const modules = [
  /* =========================
     ZÓCALOS / BANQUINA
     ========================= */
  {
    type: "BANQUINA-800-150",
    aiTag: "BANQ",
    title: "Banquina",
    subtitle: "10 / 12 / 15 cm",
    section: "ZO",
    sectionLabel: "BANQUINA ESTABLECIDA",
    width: 80,
    height: 15,
    src: "/assets/modules/zocalo/BANQUINA-800-150.png",
    isLinear: true,
    allowedHeights: [10, 12, 15],
    defaultLinearWidth: 80,
    row: "base",
    ai: {
      row: "base",
      family: "skirting",
      depth_cm: 60,
      front_plane: "flush",
      shape: "linear-skirting",
      open: false,
      doors: 0,
      drawers: 0,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "banquina/zócalo visible alineado, línea continua; mismo acabado que frentes",
    },
  },
  {
    type: "ZOCALO-800-150",
    aiTag: "ZO-ALU",
    title: "Zócalo",
    subtitle: "10 / 12 / 15 cm",
    section: "ZO",
    sectionLabel: "ZÓCALO ALUMINIO",
    width: 80,
    height: 15,
    src: "/assets/modules/zocalo/ZOCALO-800-150.png",
    isLinear: true,
    allowedHeights: [10, 12, 15],
    defaultLinearWidth: 80,
    row: "base",
    ai: {
      row: "base",
      family: "skirting",
      depth_cm: 60,
      front_plane: "flush",
      shape: "linear-skirting",
      open: false,
      doors: 0,
      drawers: 0,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "zócalo aluminio simple, línea horizontal continua sin cortes al frente",
    },
  },

  /* =========================
     BAJO MESADA
     ========================= */
  {
    type: "bm2p",
    aiTag: "BM-2P",
    title: "BM 2 Puertas",
    subtitle: "1 Estante",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 100,
    height: 78,
    src: "/assets/modules/bajo-mesada/bm2p.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-doors",
      doors: 2,
      drawers: 0,
      open: false,
      orientation: "vertical",
      bbox_policy: "strict",
      allow_autofill: false,
      visual_signature: { seams_vertical: 1, seams_horizontal: 0 }
    },
    aiHints: {
      common:
        "bajo mesada de 2 PUERTAS VERTICALES; una junta vertical. NO líneas horizontales.",
      started: "tiradores rectos visibles",
      premium: "sin tiradores; perfil gola / uñero J continuo",
      deluxe: "sin tiradores; gola oculta o uñero J minimal",
    },
  },
  {
    type: "BM-1P",
    aiTag: "BM-1P",
    title: "BM 1 Puerta",
    subtitle: "1 Estante",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 50,
    height: 78,
    src: "/assets/modules/bajo-mesada/BM-1P.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-doors",
      doors: 1,
      drawers: 0,
      open: false,
      orientation: "vertical",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "bajo mesada de 1 PUERTA VERTICAL. Frente liso.",
      started: "tirador recto visible",
      premium: "sin tirador; perfil gola / uñero J",
      deluxe: "sin tirador; gola oculta",
    },
  },
  {
    type: "2-drawer-cabinet",
    aiTag: "BM-2DR",
    title: "BM Cajonero",
    subtitle: "2 Cajones",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 100,
    height: 78,
    src: "/assets/modules/bajo-mesada/2-drawer-cabinet.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-drawers",
      doors: 0,
      drawers: 2,
      open: false,
      orientation: "horizontal",
      bbox_policy: "strict",
      allow_autofill: false,
      visual_signature: { drawers: 2 }
    },
    aiHints: {
      common: "cajonera EXACTAMENTE 2 cajones (2 líneas horizontales visibles).",
      started: "tiradores rectos visibles",
      premium: "sin tiradores; gola / uñero J",
      deluxe: "sin tiradores; gola oculta",
    },
  },
  {
    type: "3-drawer-cabinet",
    aiTag: "BM-3DR",
    title: "BM Cajonero",
    subtitle: "3 Cajones Opc. 1",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 100,
    height: 78,
    src: "/assets/modules/bajo-mesada/3-drawer-cabinet.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-drawers",
      doors: 0,
      drawers: 3,
      open: false,
      orientation: "horizontal",
      bbox_policy: "strict",
      allow_autofill: false,
      visual_signature: { drawers: 3 }
    },
    aiHints: {
      common:
        "cajonera EXACTAMENTE 3 cajones (superior más bajo). No convertir en puertas.",
      started: "tiradores rectos",
      premium: "sin tiradores; gola / uñero J",
      deluxe: "sin tiradores; gola oculta",
    },
  },
  {
    type: "3-drawer-cabinet2",
    aiTag: "BM-3DR",
    title: "BM Cajonero",
    subtitle: "3 Cajones Opc. 2",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 100,
    height: 78,
    src: "/assets/modules/bajo-mesada/3-drawer-cabinet2.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-drawers",
      doors: 0,
      drawers: 3,
      open: false,
      orientation: "horizontal",
      bbox_policy: "strict",
      allow_autofill: false,
      visual_signature: { drawers: 3 }
    },
    aiHints: {
      common:
        "cajonera EXACTAMENTE 3 cajones (variación). Mantener 3 líneas horizontales.",
      started: "tiradores rectos",
      premium: "sin tiradores; gola / uñero J",
      deluxe: "sin tiradores; gola oculta",
    },
  },
  {
    type: "BM-oven",
    aiTag: "HORNO",
    title: "BM Horno",
    subtitle: "Horno Empotrado",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 60,
    height: 78,
    src: "/assets/modules/bajo-mesada/BM-oven.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-oven",
      doors: 0,
      drawers: 0,
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "HORNO empotrado bajo mesada; frente vidrio/acero. No sustituir por cajones.",
    },
  },
  {
    type: "BM-trash-can",
    aiTag: "BM-TRASH",
    title: "BM Residuos",
    subtitle: "Cesto de residuos integrado",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 40,
    height: 78,
    src: "/assets/modules/bajo-mesada/BM-trash-can.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-drawer",
      doors: 0,
      drawers: 1,
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "módulo de residuos tipo cajón. Mostrar frente liso, no el cesto.",
      started: "tirador visible",
      premium: "sin tirador; gola",
      deluxe: "sin tirador; gola oculta",
    },
  },
  {
    type: "spice-rack",
    aiTag: "SPICE",
    title: "BM Especiero Cajón",
    subtitle: "20 x 90 cm",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 20,
    height: 78,
    src: "/assets/modules/bajo-mesada/spice-rack.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-drawer",
      doors: 0,
      drawers: 1,
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "especiero tipo cajón angosto. No convertir en puerta.",
      started: "tirador visible",
      premium: "sin tirador; gola",
      deluxe: "sin tirador; gola oculta",
    },
  },
  {
    type: "storekeeper",
    aiTag: "BODEGA",
    title: "BM Bodeguero",
    subtitle: "6 Vinos - 15 x 90 cm",
    section: "BM",
    sectionLabel: "BAJO MESADA",
    width: 15,
    height: 78,
    src: "/assets/modules/bajo-mesada/storekeeper.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "base-open",
      open: true,
      doors: 0,
      drawers: 0,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "bodeguero ABIERTO (rejilla/compartimentos). Sin puertas.",
    },
  },
  

  /* =========================
     ALACENAS (SUPERIORES 35 cm)
     ========================= */
  {
    type: "Ala35-2P-v",
    aiTag: "AL-2PV",
    title: "AL 2 Puertas",
    subtitle: "2 Puertas + Estante. Prof. 35 cm",
    section: "ALA",
    sectionLabel: "ALACENA",
    width: 100,
    height: 60,
    src: "/assets/modules/alacenas/Ala35-2P-v.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upper35",
      depth_cm: 35,
      front_plane: "recessed",
      shape: "upper-doors",
      doors: 2,
      drawers: 0,
      open: false,
      orientation: "vertical",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "alacena superior 2 puertas VERTICALES (frente cerrado).",
      started: "tiradores visibles",
      premium: "sin tiradores; PUSH-OPEN",
      deluxe: "sin tiradores; PUSH-OPEN",
    },
  },
  {
    type: "Ala35-1P",
    aiTag: "AL-1PD",
    title: "AL 1 Puerta",
    subtitle: "1 Puerta + Estante. Prof. 35 cm",
    section: "ALA",
    sectionLabel: "ALACENA",
    width: 50,
    height: 60,
    src: "/assets/modules/alacenas/Ala35-1P.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upper35",
      depth_cm: 35,
      front_plane: "recessed",
      shape: "upper-doors",
      doors: 1,
      drawers: 0,
      open: false,
      orientation: "vertical",
      hinge: "right",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "alacena 1 puerta vertical, frente cerrado.",
      started: "tirador visible",
      premium: "sin tirador; PUSH-OPEN",
      deluxe: "sin tirador; PUSH-OPEN",
    },
  },
  {
    type: "AlaH35-2P",
    aiTag: "AL-H-2P",
    title: "AL 2 Puertas (Horizontal)",
    subtitle: "2 Puertas Horizontal +1 Estante. Prof. 35 cm",
    section: "ALA",
    sectionLabel: "ALACENA",
    width: 100,
    height: 60,
    src: "/assets/modules/alacenas/AlaH35-2P.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upper35",
      depth_cm: 35,
      front_plane: "recessed",
      shape: "upper-doors",
      doors: 2,
      drawers: 0,
      open: false,
      orientation: "horizontal",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "alacena superior de PUERTAS HORIZONTALES (alzada). No convertir a vertical.",
      started: "tiradores visibles",
      premium: "sin tiradores; PUSH-OPEN",
      deluxe: "sin tiradores; PUSH-OPEN",
    },
  },
  {
    type: "AlaH35-1P",
    aiTag: "AL-H-1P",
    title: "AL 1 Puerta (Horizontal)",
    subtitle: "1 Puerta Horizontal. Prof. 35 cm",
    section: "ALA",
    sectionLabel: "ALACENA",
    width: 100,
    height: 30,
    src: "/assets/modules/alacenas/AlaH35-1P.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upper35",
      depth_cm: 35,
      front_plane: "recessed",
      shape: "upper-doors",
      doors: 1,
      drawers: 0,
      open: false,
      orientation: "horizontal",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "alacena 1 puerta HORIZONTAL abatible; frente cerrado.",
      started: "tirador discreto",
      premium: "sin tirador; PUSH-OPEN",
      deluxe: "sin tirador; PUSH-OPEN",
    },
  },
  {
    type: "Ala-extra",
    aiTag: "AL-EXT",
    title: "AL 1 Puerta + Extractor",
    subtitle: "1 Puerta + Extractor. Prof. 35 cm",
    section: "ALA",
    sectionLabel: "ALACENA",
    width: 60,
    height: 60,
    src: "/assets/modules/alacenas/Ala-extra.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upper35",
      depth_cm: 35,
      front_plane: "recessed",
      shape: "upper-extractor",
      doors: 1,
      drawers: 0,
      open: false,
      extractor: true,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "alacena 1 puerta vertical con EXTRACTOR oculto en el inferior; frente cerrado.",
      started: "tirador visible",
      premium: "sin tirador; PUSH-OPEN",
      deluxe: "sin tirador; PUSH-OPEN",
    },
  },
  {
    type: "AlaH35-SP",
    aiTag: "AL-SP",
    title: "AL Sin Puertas",
    subtitle: "1 Estante. Prof. 35 cm",
    section: "ALA",
    sectionLabel: "ALACENA",
    width: 100,
    height: 60,
    src: "/assets/modules/alacenas/AlaH35-SP.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upper35",
      depth_cm: 35,
      front_plane: "recessed",
      shape: "upper-open",
      open: true,
      doors: 0,
      drawers: 0,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "alacena superior SIN PUERTAS; 1 estante horizontal visible.",
    },
  },
  {
    type: "AlaH35-SP2",
    aiTag: "AL-SP",
    title: "AL Sin Puerta",
    subtitle: "Prof. 35 cm",
    section: "ALA",
    sectionLabel: "ALACENA",
    width: 100,
    height: 30,
    src: "/assets/modules/alacenas/AlaH35-SP2.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upper35",
      depth_cm: 35,
      front_plane: "recessed",
      shape: "upper-open",
      open: true,
      doors: 0,
      drawers: 0,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "alacena superior SIN PUERTAS (abierta).",
    },
  },



  /* =========================
     ALACENAS PUENTE (58–60 cm)
     ========================= */
  {
    type: "Ala60-2P-v",
    aiTag: "AP-2PV",
    title: "AL Puente 2 Puertas",
    subtitle: "2 Puertas + Estante. Prof. 58 cm",
    section: "ALAP",
    sectionLabel: "ALACENA PUENTE",
    width: 100,
    height: 60,
    src: "/assets/modules/alacena-puente/Ala60-2P.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upperBridge",
      bridge: true,
      depth_cm: 58,
      front_plane: "flush-with-bases",
      shape: "upper-bridge",
      doors: 2,
      open: false,
      orientation: "vertical",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "alacena tipo PUENTE con 2 puertas verticales (prof. 58).",
      started: "tiradores visibles",
      premium: "sin tiradores; PUSH-OPEN",
      deluxe: "sin tiradores; PUSH-OPEN",
    },
  },
  {
    type: "Ala60-1PD",
    aiTag: "AP-1PD",
    title: "AL Puente 1 Puerta",
    subtitle: "1 Puerta + Estante. Prof. 58 cm",
    section: "ALAP",
    sectionLabel: "ALACENA PUENTE",
    width: 50,
    height: 60,
    src: "/assets/modules/alacena-puente/Ala60-1PD.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upperBridge",
      bridge: true,
      depth_cm: 58,
      front_plane: "flush-with-bases",
      shape: "upper-bridge",
      doors: 1,
      open: false,
      orientation: "vertical",
      hinge: "right",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "puente con 1 puerta vertical , prof. 58.",
      started: "tirador visible",
      premium: "sin tirador; PUSH-OPEN",
      deluxe: "sin tirador; PUSH-OPEN",
    },
  },
  {
    type: "AlaH60-2P",
    aiTag: "AP-H-2P",
    title: "AL Puente 2 Puertas (Horizontal)",
    subtitle: "2 Puertas Horizontal +1 Estante. Prof. 58 cm",
    section: "ALAP",
    sectionLabel: "ALACENA PUENTE",
    width: 100,
    height: 60,
    src: "/assets/modules/alacena-puente/AlaH60-2P.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upperBridge",
      bridge: true,
      depth_cm: 58,
      front_plane: "flush-with-bases",
      shape: "upper-bridge",
      doors: 2,
      open: false,
      orientation: "horizontal",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "puente con puertas HORIZONTALES; prof. 58. No transformar a vertical.",
      started: "tiradores visibles",
      premium: "sin tiradores; PUSH-OPEN",
      deluxe: "sin tiradores; PUSH-OPEN",
    },
  },
  {
    type: "AlaH60-1P",
    aiTag: "AP-H-1P",
    title: "AL Puente 1 Puerta (Horizontal)",
    subtitle: "1 Puerta Horizontal. Prof. 58 cm",
    section: "ALAP",
    sectionLabel: "ALACENA PUENTE",
    width: 100,
    height: 30,
    src: "/assets/modules/alacena-puente/AlaH60-1P.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upperBridge",
      bridge: true,
      depth_cm: 58,
      front_plane: "flush-with-bases",
      shape: "upper-bridge",
      doors: 1,
      open: false,
      orientation: "horizontal",
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "puente con 1 puerta HORIZONTAL abatible; prof. 58.",
      started: "tirador visible",
      premium: "sin tirador; PUSH-OPEN",
      deluxe: "sin tirador; PUSH-OPEN",
    },
  },
  {
    type: "Ala-extra60",
    aiTag: "AP-EXT",
    title: "AL Puente + Extractor",
    subtitle: "1 Puerta + Extractor. Prof. 58 cm",
    section: "ALAP",
    sectionLabel: "ALACENA PUENTE",
    width: 60,
    height: 60,
    src: "/assets/modules/alacena-puente/Ala-extra60.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upperBridge",
      bridge: true,
      depth_cm: 58,
      front_plane: "flush-with-bases",
      shape: "upper-bridge-extractor",
      extractor: true,
      doors: 1,
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "puente con 1 puerta vertical y EXTRACTOR oculto (prof. 58).",
      started: "tirador visible",
      premium: "sin tirador; PUSH-OPEN",
      deluxe: "sin tirador; PUSH-OPEN",
    },
  },
  {
    type: "AlaH60-SP",
    aiTag: "AP-SP",
    title: "AL Puente Sin Puertas",
    subtitle: "1 Estante. Prof. 58 cm",
    section: "ALAP",
    sectionLabel: "ALACENA PUENTE",
    width: 100,
    height: 60,
    src: "/assets/modules/alacena-puente/AlaH60-SP.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upperBridge",
      bridge: true,
      depth_cm: 58,
      front_plane: "flush-with-bases",
      shape: "upper-bridge-open",
      open: true,
      doors: 0,
      drawers: 0,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "puente SIN PUERTAS; 1 estante horizontal visible (prof. 58).",
    },
  },
  {
    type: "AlaH60-SP2",
    aiTag: "AP-SP",
    title: "AL Puente Sin Puerta",
    subtitle: "Prof. 58 cm",
    section: "ALAP",
    sectionLabel: "ALACENA PUENTE",
    width: 100,
    height: 30,
    src: "/assets/modules/alacena-puente/AlaH60-SP2.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upperBridge",
      bridge: true,
      depth_cm: 58,
      front_plane: "flush-with-bases",
      shape: "upper-bridge-open",
      open: true,
      doors: 0,
      drawers: 0,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "puente SIN PUERTAS (prof. 58).",
    },
  },
  

  /* =========================
     ESPECIALES (COLUMNAS)
     ========================= */
  {
    type: "colum1",
    aiTag: "COL-1",
    title: "AL Columna 1",
    subtitle: "60 × 140 cm - 1 Cajón + Horno + Micro",
    section: "ESP",
    sectionLabel: "ESPECIALES",
    width: 60,
    height: 140,
    src: "/assets/modules/especiales/colum1.png",
    row: "tall",
    ai: {
      row: "tall",
      family: "tall",
      column: true,
      depth_cm: 60,
      front_plane: "flush",
      shape: "tall-column",
      drawers: 1,
      oven: true,
      microwave: true,
      bbox_policy: "strict",
      allow_autofill: false,
      visual_signature: { column: true }
    },
    aiHints: {
      common:
        "columna alta con 1 cajón inferior, horno y nicho microondas.",
      started: "tiradores visibles",
      premium: "sin tiradores (gola/push) según zona",
      deluxe: "sin tiradores; al ras",
    },
  },
  {
    type: "colum2",
    aiTag: "COL-2",
    title: "AL Columna 2",
    subtitle: "60 × 140 cm - 2 Cajones + Horno",
    section: "ESP",
    sectionLabel: "ESPECIALES",
    width: 60,
    height: 140,
    src: "/assets/modules/especiales/colum2.png",
    row: "tall",
    ai: {
      row: "tall",
      family: "tall",
      column: true,
      depth_cm: 60,
      front_plane: "flush",
      shape: "tall-column",
      drawers: 2,
      oven: true,
      bbox_policy: "strict",
      allow_autofill: false,
      visual_signature: { column: true }
    },
    aiHints: {
      common: "columna alta con 2 cajones y horno.",
      started: "tiradores visibles",
      premium: "sin tiradores",
      deluxe: "sin tiradores; al ras",
    },
  },
  {
    type: "colum3",
    aiTag: "COL-3",
    title: "AL Columna 3",
    subtitle: "60 × 140 cm - 1 Puerta + 1 Estante + Horno",
    section: "ESP",
    sectionLabel: "ESPECIALES",
    width: 60,
    height: 140,
    src: "/assets/modules/especiales/colum3.png",
    row: "tall",
    ai: {
      row: "tall",
      family: "tall",
      column: true,
      depth_cm: 60,
      front_plane: "flush",
      shape: "tall-column",
      doors: 1,
      drawers: 0,
      oven: true,
      hinge: "left",
      bbox_policy: "strict",
      allow_autofill: false,
      visual_signature: { column: true }
    },
    aiHints: {
      common:
        "columna con 1 puerta (apertura izquierda), estante y horno.",
      started: "tiradores visibles",
      premium: "sin tiradores",
      deluxe: "sin tiradores; al ras",
    },
  },
  {
    type: "colum4",
    aiTag: "COL-4",
    title: "AL Columna 4",
    subtitle: "60 × 140 cm - 1 Puerta + 3 Estantes",
    section: "ESP",
    sectionLabel: "ESPECIALES",
    width: 60,
    height: 140,
    src: "/assets/modules/especiales/colum4.png",
    row: "tall",
    ai: {
      row: "tall",
      family: "tall",
      column: true,
      depth_cm: 60,
      front_plane: "flush",
      shape: "tall-column",
      doors: 1,
      hinge: "left",
      shelves: 2,
      bbox_policy: "strict",
      allow_autofill: false,
      visual_signature: { column: true }
    },
    aiHints: {
      common: "columna despensa con 1 puerta y 3 estantes.",
      started: "tiradores visibles",
      premium: "sin tiradores",
      deluxe: "sin tiradores; al ras",
    },
  },

  /* =========================
     ELECTRO
     ========================= */
  {
    type: "fridge-right",
    aiTag: "FRIDGE60",
    title: "Heladera 1",
    subtitle: "60 × 180 cm",
    section: "ELECTRO",
    sectionLabel: "ELECTRODOMESTICO",
    width: 60,
    height: 180,
    src: "/assets/modules/electro/fridge-right.png",
    row: "tall",
    ai: {
      row: "tall",
      family: "tall",
      depth_cm: 60,
      front_plane: "flush",
      shape: "appliance-fridge",
      appliance: "fridge",
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "heladera independiente (acero). NO colocar muebles encima salvo que estén listados.",
    },
  },
  {
    type: "double-fridge-right",
    aiTag: "FRIDGE-DBL",
    title: "Heladera 2",
    subtitle: "91 × 178 cm",
    section: "ELECTRO",
    sectionLabel: "ELECTRODOMESTICO",
    width: 91,
    height: 178,
    src: "/assets/modules/electro/double-fridge-right.png",
    row: "tall",
    ai: {
      row: "tall",
      family: "tall",
      depth_cm: 70,
      front_plane: "flush",
      shape: "appliance-fridge",
      appliance: "fridge-side-by-side",
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "heladera side-by-side (dos puertas anchas). NO mueble superior salvo listado.",
    },
  },
  {
    type: "built-in-range",
    aiTag: "COC-HORNO",
    title: "Cocina-Horno",
    subtitle: "60 × 105 cm",
    section: "ELECTRO",
    sectionLabel: "ELECTRODOMESTICO",
    width: 60,
    height: 105,
    src: "/assets/modules/electro/built-in-range.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "appliance-range",
      appliance: "range",
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common:
        "cocina con horno (4 hornallas). Frente acero. No reemplazar por cajonera.",
    },
  },
  {
    type: "microwave",
    aiTag: "MICRO",
    title: "Microondas",
    subtitle: "48 × 30 cm",
    section: "ELECTRO",
    sectionLabel: "ELECTRODOMESTICO",
    width: 48,
    height: 30,
    src: "/assets/modules/electro/microwave.png",
    row: "upper",
    ai: {
      row: "upper",
      family: "upper",
      subfamily: "upper35",
      depth_cm: 35,
      front_plane: "recessed",
      shape: "appliance-micro",
      appliance: "microwave",
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "microondas en estante/zona superior. Frente acero.",
    },
  },
  {
    type: "washing-machine",
    aiTag: "LAVAR",
    title: "Lavarropas",
    subtitle: "60 × 85 cm",
    section: "ELECTRO",
    sectionLabel: "ELECTRODOMESTICO",
    width: 60,
    height: 85,
    src: "/assets/modules/electro/washing-machine.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "appliance-washer",
      appliance: "washing-machine",
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "lavarropas bajo mesada.",
    },
  },
  {
    type: "dishwasher",
    aiTag: "LAVAV",
    title: "Lavavajillas",
    subtitle: "60 × 85 cm",
    section: "ELECTRO",
    sectionLabel: "ELECTRODOMESTICO",
    width: 60,
    height: 85,
    src: "/assets/modules/electro/dishwasher.png",
    row: "base",
    ai: {
      row: "base",
      family: "base",
      depth_cm: 60,
      front_plane: "flush",
      shape: "appliance-dishwasher",
      appliance: "dishwasher",
      open: false,
      bbox_policy: "strict",
      allow_autofill: false
    },
    aiHints: {
      common: "lavavajillas bajo mesada.",
    },
  },
];

export default modules;
